import React, { useEffect, useState } from "react";

import "./index.css";
import { Route } from "./Routes/index";

import { useDispatch, useSelector } from "react-redux";
import { loadFromStorage } from "./slices/user/reducer";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "./Components/ui/LoadingSpinner";
import { authInstance } from "./api/axiosInstance";
import { setLogo, setSiteData } from "./slices/website/reducer";
import { ToastContainer } from "react-toastify";
// import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
function App() {
  const dispatch = useDispatch();
  const [themeLoaded, setThemeLoaded] = useState(false);
  const { siteData } = useSelector((state) => state.website);
  useEffect(() => {
    dispatch(loadFromStorage());
  }, [dispatch]);
  useEffect(() => {
    if (siteData) return;
    const fetchSiteData = async () => {
      try {
        const response = await authInstance.get(`/settings`);
        dispatch(setSiteData(response.data?.data || response.data));
        dispatch(setLogo(response.data?.data?.logo || response.data?.logo));
      } catch (error) {
        console.error("Error fetching site data:", error);
      }
    };

    fetchSiteData();
  }, [siteData]);
  useEffect(() => {
    if (!siteData?.favicon) return;

    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    if (siteData.favicon.endsWith(".svg")) {
      link.type = "image/svg+xml";
    } else if (siteData.favicon.endsWith(".png")) {
      link.type = "image/png";
    } else {
      link.type = "image/x-icon";
    }

    link.href = `${siteData.favicon}?v=${Date.now()}`;
  }, [siteData]);

  useEffect(() => {
    import("./assets/scss/themes.scss").then(() => {
      setThemeLoaded(true);
    });
  }, []);

  // if (!themeLoaded) {
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         fontSize: "20px",
  //         fontWeight: "600",
  //       }}
  //     >
  //       Loading …
  //     </div>
  //   );
  // }
  if (!themeLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Route />
    </React.Fragment>
  );
}

export default App;
